export default "__VITE_ASSET__635469bc__"